/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify, unescapeHtml } from "helpers";
import LinesEllipsis from "react-lines-ellipsis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import Bundle from "components/Bundle";
import PriceFormat from "../../PriceFormat/index";

const FeaturedProduct = props => {
  const {
    ce,
    sku,
    featImg,
    logo,
    partner,
    title,
    bundleCount,
    shortDescription,
    discountPrice,
    cost
  } = props;

  const shortDescriptionHTML = shortDescription && (
    <p dangerouslySetInnerHTML={{ __html: unescapeHtml(shortDescription) }} />
  );
  const [cardImage, updateCardImage] = useState(null);
  const [onHover, handleHoverState] = useState(false);
  useEffect(() => {
    if (featImg) {
      if (
        featImg.endsWith(".jpg") === true ||
        featImg.endsWith(".jpeg") === true ||
        featImg.endsWith(".png") === true
      ) {
        updateCardImage(`${featImg.replace(/\s/g, "%20")}`);
      }
    }
  }, [featImg]);

  return (
    <div
      className="singleFeaturedProductHolder"
      onMouseEnter={() => handleHoverState(true)}
      onMouseLeave={() => handleHoverState(false)}
    >
      <div className="singleFeaturedProduct">
        {ce > 0 && (
          <div className="ceRectangle">
            <span>CE</span>
          </div>
        )}
        <div
          style={
            cardImage && {
              backgroundImage: `url(${cardImage})`
            }
          }
          className="singleFeaturedProduct__featImg"
        />
        <div className="singleFeaturedProduct__info">
          {title && (
            <LinesEllipsis
              text={title}
              maxLine={2}
              ellipsis="..."
              trimRight={false}
              basedOn="letters"
              className="singleFeaturedProduct__info--title"
            />
          )}
          <div className="singleFeaturedProduct__info--bundle">
            <Bundle bundleCount={bundleCount} />
          </div>
          {onHover && (
            <div>
              {shortDescription && (
                <LinesEllipsis
                  text={shortDescriptionHTML}
                  ellipsis="..."
                  trimRight={false}
                  basedOn="letters"
                  className="singleFeaturedProduct__info--description"
                />
              )}
            </div>
          )}
          {logo && (
            <div className="singleFeaturedProduct__logo">
              <div
                style={{ backgroundImage: `url(${logo})` }}
                aria-label={partner}
                role="dialog"
              >
                {" "}
              </div>
            </div>
          )}
          <div className="singleFeaturedProduct__pricing">
            {discountPrice < cost && discountPrice != null ? (
              <>
                <FontAwesomeIcon icon={faTag} />
                <p className="singleFeaturedProduct__pricing--discounted">
                  <PriceFormat id="priceFormat" value={cost} />
                </p>
                <p className="singleFeaturedProduct__pricing--cost">
                  <PriceFormat id="priceFormat" value={discountPrice} />
                </p>
              </>
            ) : cost === 0 ? (
              <>
                <p className="singleFeaturedProduct__pricing--cost">Free</p>
              </>
            ) : (
              <p className="singleFeaturedProduct__pricing--cost">
                <PriceFormat id="priceFormat" value={cost} />
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="singleFeaturedProductHolder__fadeout" />
      <Link title={title} to={`/products/${slugify(title)}-${sku}`}>
        {" "}
      </Link>
    </div>
  );
};

FeaturedProduct.propTypes = {
  ce: PropTypes.bool,
  sku: PropTypes.string,
  featImg: PropTypes.string,
  logo: PropTypes.string,
  partner: PropTypes.string,
  title: PropTypes.string,
  bundleCount: PropTypes.number,
  shortDescription: PropTypes.string,
  cost: PropTypes.number,
  discountPrice: PropTypes.number
};

FeaturedProduct.defaultProps = {
  ce: null,
  sku: null,
  featImg: null,
  logo: null,
  partner: null,
  title: null,
  bundleCount: null,
  shortDescription: null,
  cost: null,
  discountPrice: null
};

export default FeaturedProduct;
